import { getFromLocalStorage } from "helpers/localstorage";
import img from "../../assets/images/logo-2.png";
import imgNikon from "../../assets/images/logo-Nikon.png";
import { useMemo } from "react";

export const Logo = (props: any) => {
  const { agencyName } = getFromLocalStorage() ?? {};

  const image = useMemo(() => {
    if (String(agencyName)?.toLowerCase() === 'nikon' || String(agencyName)?.toLowerCase() === 'nital')
      return imgNikon;
    return img;
  }, [agencyName]);

  return (
    // Insert SVG + path
    // <img {...props} src={logo} alt="logo" />
    <img style={{ height: "50px", width: "auto" }} src={image} alt="logo" />
  );
};
